import gql from "graphql-tag";

export default gql`
  fragment FiAddress on FiAddress {
    line1
    city
    postalCode
  }
`;
